import { render, staticRenderFns } from "./AreasView.vue?vue&type=template&id=6ae5dfba&scoped=true&"
import script from "./AreasView.vue?vue&type=script&lang=js&"
export * from "./AreasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5dfba",
  null
  
)

export default component.exports